import {
    GQApprovalInput,
    GQApprovalTokenGroupInput,
    GQApprovalTokenInput,
} from "graphql-sdk";
import {
    IApprovalSave,
    IApprovalTokenGroupSave,
    IApprovalTokenSave,
} from "../..";
import type { ValidationSchema } from "../validation";

export const schemaApproval: ValidationSchema<GQApprovalInput> = {
    type: { required: true },
    active: { required: true },
};

export const defaultApproval: IApprovalSave = {
    type: undefined,
    active: true,
    tokenIds: [],
    tokenGroupIds: [],
};

export const schemaApprovalToken: ValidationSchema<GQApprovalTokenInput> = {
    name: { required: true },
    value: { required: true },
    type: { required: true },
    active: { required: true },
};

export const defaultApprovalToken: IApprovalTokenSave = {
    name: "",
    approvalTokenGroupId: undefined,
    value: "",
    type: "CODE",
    active: true,
};

export const schemaApprovalTokenGroup: ValidationSchema<GQApprovalTokenGroupInput> =
    {
        name: { required: true },
        active: { required: true },
    };

export const defaultApprovalTokenGroup: IApprovalTokenGroupSave = {
    name: "",
    active: true,
};
